import { useTranslation } from "react-i18next";
import AppStoreIcon from "../../images/icons/app-store.svg";
import GooglePlayIcon from "../../images/icons/google-play.svg";
import InvoiceArImg from "../../images/invoice-phone-ar.png";
import InvoiceEnImg from "../../images/invoice-phone-en.png";
import InvoiceArSmImg from "../../images/invoice-phone-ar-sm.png";
import InvoiceEnSmImg from "../../images/invoice-phone-en-sm.png";

const DownloadApp = () => {
  const { t, i18n } = useTranslation();

  return (
    <section id="download-app" className="bg-surface">
      <div className="relative container mx-auto py-10 lg:pt-40 lg:pb-20 flex flex-col justify-center items-center gap-20 px-4 md:px-0">
        <div className="flex flex-col items-center lg:items-start w-full text-center rtl:md:text-right ltr:md:text-left bg-lightPrimary/15 shadow-20 rounded-20 px-3 md:px-14 py-16">
          <p className="text-grayDarkness text-3xl md:text-6xl font-bold pb-0 md:pb-8">
            {t("downloadApp.title")}
          </p>
          <p className="text-primary text-3xl md:text-6xl font-bold">
            {t("downloadApp.subtitle")}
          </p>

          <p className="mt-10 w-full md:w-3/5 text-center rtl:md:text-right ltr:md:text-left">
            {t("downloadApp.description")}
          </p>

          <div className="mt-10 flex flex-col md:flex-row items-center gap-3 md:gap-4">
            <a
              href="https://apps.apple.com/us/app/specter-app/id1667869308"
              target="_blank"
              rel="noreferrer"
            >
              <img
                src={AppStoreIcon}
                alt="App Store"
                className="w-full inline-block cursor-pointer hover:scale-105 transition-all duration-500"
              />
            </a>
            <a href="/" target="_blank" rel="noreferrer">
              <img
                src={GooglePlayIcon}
                alt="Google Play"
                className="w-full inline-block cursor-pointer hover:scale-105 transition-all duration-500"
              />
            </a>
          </div>

          <img
            src={i18n.language === "ar" ? InvoiceArSmImg : InvoiceEnSmImg}
            className="block lg:hidden mt-10"
            alt="Specter App"
          />
        </div>
        <img
          src={i18n.language === "ar" ? InvoiceArImg : InvoiceEnImg}
          className="absolute bottom-20 rtl:left-0 ltr:right-0 max-h-[650px] hidden lg:block"
          alt="Specter App"
        />
      </div>
    </section>
  );
};

export default DownloadApp;
